import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navigation.css';

export function Navigation() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/sslmo/login');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const navigationItems = [];

  // 역할별 메뉴 구성
  if (user?.role === 'collector') {
    // 수거 작업자 전용 메뉴
    navigationItems.push(
      { path: '/sslmo/collector/dashboard', label: '작업자 대시보드', icon: '🚛' },
      { path: '/sslmo/collector/tasks', label: '배정된 작업', icon: '📋' },
      { path: '/sslmo/profile', label: '내 프로필', icon: '👤' }
    );
  } else {
    // 일반 사용자 메뉴
    navigationItems.push(
      { path: '/sslmo/dashboard', label: '대시보드', icon: '🏠' },
      { path: '/sslmo/collection', label: '수거 요청', icon: '🥬' },
      { path: '/sslmo/history', label: '수거 내역', icon: '📋' },
      { path: '/sslmo/billing', label: '결제 내역', icon: '💳' },
      { path: '/sslmo/analysis', label: '수거 분석', icon: '📊' },
      { path: '/sslmo/profile', label: '프로필', icon: '👤' }
    );
  }

  // 관리자 전용 메뉴
  if (user?.role === 'admin') {
    navigationItems.push({ path: '/sslmo/admin', label: '로그인', icon: '⚙️' });
  }

  return (
    <nav className="navigation" role="navigation" aria-label="주 메뉴">
      <div className="nav-container">
        {/* 로고 및 브랜드 */}
        <div className="nav-brand">
          <Link to="/sslmo/dashboard" className="brand-link">
            <span className="brand-icon">♻️</span>
            <span className="brand-text">SSLMO</span>
          </Link>
        </div>

        {/* 데스크톱 메뉴 */}
        <div className="nav-menu desktop-menu">
          {navigationItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              aria-current={location.pathname === item.path ? 'page' : undefined}
            >
              <span className="nav-icon" aria-hidden="true">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </div>

        {/* 사용자 정보 및 로그아웃 */}
        <div className="nav-user">
          <div className="user-info">
            <span className="user-avatar" aria-hidden="true">👤</span>
            <div className="user-details">
              <span className="user-name">{user?.full_name || user?.username}</span>
              <span className="user-role">
                {user?.role === 'admin' ? '관리자' : user?.role === 'collector' ? '수거작업자' : '사용자'}
              </span>
            </div>
          </div>
          <button 
            onClick={handleLogout} 
            className="logout-button"
            aria-label="로그아웃"
          >
            로그아웃
          </button>
        </div>

        {/* 모바일 메뉴 토글 */}
        <button
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-expanded={isMobileMenuOpen}
          aria-controls="mobile-menu"
          aria-label="메뉴 토글"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>

      {/* 모바일 메뉴 */}
      <div 
        id="mobile-menu"
        className={`nav-menu mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}
        aria-hidden={!isMobileMenuOpen}
      >
        {navigationItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(false)}
            aria-current={location.pathname === item.path ? 'page' : undefined}
          >
            <span className="nav-icon" aria-hidden="true">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </Link>
        ))}
        <div className="mobile-user-section">
          <div className="mobile-user-info">
            <span className="user-name">{user?.full_name || user?.username}</span>
            <span className="user-role">
              {user?.role === 'admin' ? '관리자' : user?.role === 'collector' ? '수거작업자' : '사용자'}
            </span>
          </div>
          <button 
            onClick={handleLogout} 
            className="mobile-logout-button"
            aria-label="로그아웃"
          >
            로그아웃
          </button>
        </div>
      </div>

      {/* 모바일 메뉴 오버레이 */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-menu-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
          aria-hidden="true"
        ></div>
      )}
    </nav>
  );
}